import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import DashboardClient from '../components/DashboardClient';

export default function DashboardPage() {
  const { t } = useTranslation(['dashboard', 'common']);
  
  // Mock data for dashboard - you can replace this with API calls to Django
  const mockDashboardData = {
    initialStats: [
      {
        title: t('stats.totalPatients'),
        value: "2,546",
        change: { value: 12.5, trend: 'up' as 'up' },
        iconName: 'users' as const,
        color: 'blue' as const
      },
      {
        title: t('stats.appointmentsToday'), 
        value: "24",
        change: { value: 8.2, trend: 'up' as 'up' },
        iconName: 'calendar' as const,
        color: 'green' as const
      },
      {
        title: t('stats.revenueThisMonth'),
        value: "$32,450",
        change: { value: 5.8, trend: 'up' as 'up' },
        iconName: 'currency' as const,
        color: 'amber' as const
      },
      {
        title: t('stats.documentsProcessed'),
        value: "1,204",
        change: { value: 2.3, trend: 'down' as 'down' },
        iconName: 'document' as const,
        color: 'purple' as const
      }
    ],
    initialActivities: [
      {
        id: "act1",
        type: "appointment" as const,
        title: "Dr. Thompson - Dental Checkup",
        description: "Patient: John Smith - Regular checkup and cleaning",
        time: "10:30 AM",
        status: "completed" as const
      },
      {
        id: "act2",
        type: "patient" as const,
        title: "New Patient Registration",
        description: "Emma Johnson - Initial assessment scheduled",
        time: "11:15 AM", 
        status: "pending" as const
      },
      {
        id: "act3",
        type: "payment" as const,
        title: "Invoice #1234 Paid",
        description: "Root canal treatment - $850.00",
        time: "12:45 PM",
        status: "completed" as const
      },
      {
        id: "act4",
        type: "appointment" as const,
        title: "Dr. Chen - Orthodontic Consultation",
        description: "Patient: Michael Brown - Braces adjustment",
        time: "2:00 PM",
        status: "pending" as const
      }
    ]
  };
  
  return (
    <>
      <Helmet>
        <title>{t('title')} - {t('common:appName')}</title>
        <meta name="description" content={t('subtitle')} />
      </Helmet>
      
      <DashboardClient 
        initialStats={mockDashboardData.initialStats}
        initialActivities={mockDashboardData.initialActivities}
      />
    </>
  );
}
